import { render, staticRenderFns } from "./FundResult.vue?vue&type=template&id=a9451566&scoped=true"
import script from "./FundResult.vue?vue&type=script&lang=js"
export * from "./FundResult.vue?vue&type=script&lang=js"
import style0 from "./FundResult.vue?vue&type=style&index=0&id=a9451566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9451566",
  null
  
)

export default component.exports